<template>
    <div class="like">
        <img src="@/assets/images/icons/lenta/icon_heart_red.svg" :width="size" v-if="active">
        <img src="@/assets/images/icons/lenta/icon_heart.svg" :width="size" v-else>
        <p class="like-counter" :class="{active}" :style="{fontSize: fsize + 'px'}" v-if="likes && likes.length > 0">{{likes.length}}</p>
        <Prompt v-if="prompt" :likes="likes" />
    </div>
</template>
<script>
import Prompt from '@/components/UI/Prompt.vue'
export default {
    name: 'Like',
    props: {
        active: {
            type: [Boolean, Object],
            require: true,
            default: false
        },
        likes: {
            type: Array,
            require: false
        },
        size: {
            type: Number,
            require: false
        },
        fsize: {
            type: Number,
            require: false
        },
        prompt: {
            type: Boolean,
            require: false,
            default: false
        }
    },
    components: {
        Prompt
    }
}
</script>

<style lang="stylus">
.like
    display flex
    align-items center
    cursor pointer
    position relative
    &:hover
        .prompt
            opacity 1
            z-index 2
            
    &-counter
        font-size 16px
        font-weight 500
        padding-left 7px
        line-height 0
        &.active
            color #ff3347
    
    
</style>